import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CompanyUiCustomizationService } from 'src/app/core/lib/company-ui/company.ui-customization.service';
import { CompanyUiSettings } from 'src/app/core/lib/company-ui/company.ui-settings';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss']
})
export class ErrorMessageComponent implements OnInit {
  brandName = environment.brand.name;
  brandLogo = environment.brand.theme.loginBackground;

  // ── Branding dinamico ─────────────────────────────────────────────────────
  // Logo di brand letto da environment, usato come default immediato e come
  // fallback se la company non ha un logo specifico o se il queryParam non è
  // valorizzato (es. accesso diretto alla rotta).
  readonly brandLogoSrc: string = environment.brand.theme.extendedLogo;

  // Inizializzato direttamente con il brand logo per evitare flash visivi:
  // se la company ha un logo dedicato verrà sostituito asincronamente.
  companyLogoSrc: string = this.brandLogoSrc;

  constructor(
    private activatedRoute: ActivatedRoute,
    private companyUiCustomizationService: CompanyUiCustomizationService
  ) { }

  ngOnInit() {
    // Il companyCode viene passato come queryParam dal DigitalSignatureComponent
    // al momento del redirect verso questa pagina (vedi getErrorEvent()).
    this.activatedRoute.queryParams.subscribe(async params => {
      const companyCode: string = params['company'] || '';
      if (companyCode) {
        await this.loadCompanyBranding(companyCode);
      }
    });
  }

  /**
   * Risolve il logo da mostrare in base al CompanyCode ricevuto via queryParam.
   * Se la company non ha un logo specifico, mantiene il logo di brand già
   * inizializzato come default.
   */
  private async loadCompanyBranding(companyCode: string): Promise<void> {

    const company = await this.companyUiCustomizationService.getSettings(companyCode);
    const logo = await (company ?? new CompanyUiSettings(companyCode)).getLogo();

    this.companyLogoSrc = logo.default ? this.brandLogoSrc : logo.src;

  }

}
